// import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
// import { persistStore, persistReducer } from "redux-persist";
// import storage from "redux-persist/lib/storage";
// import { createBrowserHistory } from "history";
// import { routerMiddleware } from "connected-react-router";
// import rootReducer from "./reducers";
// import createSagaMiddleware from "redux-saga";
// import rootSaga from "./sagas";

// const persistConfig = {
//   key: "root",
//   storage,
//   blacklist: ["Adviser"],
// };

// const history = createBrowserHistory();
// const sagaMiddleware = createSagaMiddleware();
// const routeMiddleware = routerMiddleware(history);

// const middleware = [...getDefaultMiddleware(), sagaMiddleware, routeMiddleware];

// const persistedReducer = persistReducer(persistConfig, rootReducer(history));

// const store = configureStore({
//   reducer: persistedReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware().concat(
//       sagaMiddleware,
//       routeMiddleware,
//     ),
//   // middleware,
//   devTools: process.env.NODE_ENV !== "production",
// });

// sagaMiddleware.run(rootSaga);

// const persistor = persistStore(store);

// export { store, persistor, history };

import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { createBrowserHistory } from "history";
import { routerMiddleware } from "connected-react-router";
import rootReducer from "./reducers";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./sagas";

// Persist configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["Auth"],
};

// Create history object
const history = createBrowserHistory();

// Create middleware
const sagaMiddleware = createSagaMiddleware();
const routeMiddleware = routerMiddleware(history);

// Configure store with middleware
const persistedReducer = persistReducer(persistConfig, rootReducer(history));

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(sagaMiddleware, routeMiddleware),
  devTools: process.env.NODE_ENV !== "production", // Enable Redux DevTools only in development
});

// Run the saga
sagaMiddleware.run(rootSaga);

// Create persistor
const persistor = persistStore(store);

// Export store, persistor, and history
export { store, persistor, history };
